import {Component, Input, OnInit, Output, ViewChild, EventEmitter, OnChanges, SimpleChanges} from '@angular/core';
import {Subscription} from "rxjs";
import {UntypedFormControl, UntypedFormGroup} from "@angular/forms";
import {MatCalendar, MatCalendarCellCssClasses} from "@angular/material/datepicker";

@Component({
    selector: 'app-move-date-with-range',
    templateUrl: './move-date-with-range.component.html',
    styleUrls: ['./move-date-with-range.component.scss'],
    standalone: false
})
export class MoveDateWithRangeComponent implements OnInit, OnChanges {
    @Input() startDateTitle: string | undefined;
    @Input() endDateTitle: string | undefined;
    @Input() public maxDate: Date;
    @Input() public settingDateMin: Date;
    @Input() public settingDateMax: Date;

    @Input() disabled: boolean = false;
    @ViewChild(MatCalendar, {static: false}) calendar: MatCalendar<Date> | undefined;
    @Output() changeDateEnd = new EventEmitter();
    @Output() changeDateStart = new EventEmitter();
    @Output() changeDate = new EventEmitter();
    @Output() changeCalendar = new EventEmitter();

    public dateForm: UntypedFormGroup;
    subscriptions: Subscription[] = [];
    showCalendar = false;
    @Input() deltaDate: number | undefined;

    constructor() {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        this.maxDate = today;
        this.settingDateMax = today;
        const beforSevenDay = new Date();
        const deltaDate = this.deltaDate ? this.deltaDate : 7;
        this.settingDateMin = beforSevenDay;

        beforSevenDay.setDate(today.getDate() - deltaDate);
        this.dateForm = new UntypedFormGroup({
            start: new UntypedFormControl({value: beforSevenDay, disabled: false}),
            end: new UntypedFormControl({value: today, disabled: false}),
        });

    }

    ngOnInit(): void {
        let subscription: Subscription | undefined = this.dateForm.valueChanges
            .subscribe((value) => {
                this.changeDate.emit(value);
            });
        this.subscriptions.push(subscription)
        this.dateForm.get('start')?.setValue(this.settingDateMin);
        subscription = this.dateForm.get('start')?.valueChanges
            .subscribe((value) => {
                this.changeDateStart.emit(value);
            });
        if (subscription != null) {
            this.subscriptions.push(subscription);
        }
        subscription = this.dateForm.get('end')?.valueChanges
            .subscribe((value) => {
                this.changeDateEnd.emit(value);
            });
        if (subscription != null) {
            this.subscriptions.push(subscription);
        }
        this.dateForm.get('end')?.setValue(this.settingDateMax);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.settingDateMax != null || changes.settingDateMin != null) {
            this.updateCalendar()
        }
    }

    updateCalendar() {
        if (this.calendar) {
            this.calendar.updateTodaysDate();
        }
    }

    changeNext() {
        if (!this.startOEndIsUnset) {
            const deltaDate = this.deltaDate ? this.deltaDate : 7;
            let end = new Date(this.settingDateMax);
            const start = new Date(end);
            start.setHours(0, 0, 0, 0);
            end.setDate(start.getDate() + deltaDate);
            if (end.getTime() > this.maxDate.getTime()) {
                end = new Date(this.maxDate.getTime())
            }
            end.setHours(0, 0, 0, 0);
            this.dateForm.get('start')?.setValue(start);
            this.dateForm.get('end')?.setValue(end);
            this.updateCalendar();
        }
        this.changeShowCalendarValue(false)
    }


    changePrevius() {
        if (!this.startOEndIsUnset) {
            const deltaDate = this.deltaDate ? this.deltaDate : 7;
            const start: Date = new Date(this.settingDateMin);
            start.setHours(0, 0, 0, 0)
            const end = new Date(start);
            end.setHours(0, 0, 0, 0)
            start.setDate(end.getDate() - deltaDate);
            this.dateForm.get('start')?.setValue(start);
            this.dateForm.get('end')?.setValue(end);
            this.updateCalendar();
        }
        this.changeShowCalendarValue(false)
    }

    get isAfterToday() {
        if (!this.startOEndIsUnset) {
            const end: Date = new Date(this.dateForm.get('end')?.value);
            end.setHours(0, 0, 0, 0);
            return end.getTime() >= this.maxDate.getTime();
        } else {
            return
        }
    }

    get startOEndIsUnset() {
        let start: Date = this.dateForm.get('start')?.value;
        const end: Date = this.dateForm.get('end')?.value;
        return start == null || end == null
    }


    isEqualsDate(date1: Date, date2: Date) {
        return date2 != null && date1 != null && date1.getDate() == date2.getDate() &&
            date1.getMonth() == date2.getMonth() &&
            date1.getFullYear() == date2.getFullYear();
    }

    isOverDate(date1: Date, date2: Date) {
        return date2 != null && date1 != null && date1.getTime() >= date2.getTime()
    }

    selectDate(event: Date | undefined | null) {

        if (event != null) {
            const start = this.dateForm.get('start')?.value;
            const end = this.dateForm.get('end')?.value;
            const setEndDate = start != null && end == null && this.isOverDate(event, start)
            if (setEndDate) {
                event.setHours(0, 0, 0, 0)
                this.dateForm.get('end')?.setValue(event);
                this.changeCalendar.emit(this.dateForm.value)
            } else {
                event.setHours(0, 0, 0, 0)
                this.dateForm.get('start')?.setValue(event);
                this.dateForm.get('end')?.reset(null, {emitEvent: false});
            }
            this.updateCalendar();
        }


    }

    dateClass = (d: Date): MatCalendarCellCssClasses => {
        const init: Date = new Date(this.settingDateMin);
        const end: Date = new Date(this.settingDateMax);
        const isBetween = (init: Date, x: Date, end: Date) => {
            if (init != null && end != null) {
                init.setHours(0, 0, 0, 0);
                end.setHours(0, 0, 0, 0);
                return init.getTime() < x.getTime() && x.getTime() < end.getTime()
            } else {
                return false;
            }
        }

        if (isBetween(init, d, end)) {
            return 'example-custom-date-class-preview'
        } else if (this.isEqualsDate(d, init) || this.isEqualsDate(d, end)) {
            return 'example-custom-date-class'
        } else {
            return ''
        }
    }


    changeShowCalendarValue(value: boolean | undefined = undefined) {
        this.showCalendar = value != null ? value : !this.showCalendar
    }

}
